import { useContext, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { AuthContext } from "context/context";
import endoso from "services/endoso";
import { CancelacionMasivaContext } from "../../../../../context";
import useStyles from "./styles";

export const SectionSelector = () => {
  const classes = useStyles();
  const { setTimer } = useContext(AuthContext);
  const { setSelected } = useContext(CancelacionMasivaContext);
  const [disabled, setDisabled] = useState(false);

  const activate = () => setDisabled(false);
  const download = () => {
    setTimer(0);
    setDisabled(true);
    endoso.descargarLayoutCancelacionMasiva(activate);
  };

  return (
    <div>
      <Typography variant="h6">
        ¿Cómo desea agregar las pólizas a cancelar?
      </Typography>
      <Grid container spacing={2} className={classes.container}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={download}
            disabled={disabled}
          >
            Descargar Plantilla de Layout
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => {
              setTimer(0);
              setSelected("archivo");
            }}
          >
            Agregar por archivo de pólizas
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
